'use client';

import { Table } from '@tanstack/react-table';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface ITableFilters<TData> {
  table: Table<TData>;
  translation: (key: string) => string;
  searchLabel: string;
  cta?: {
    label: string;
    onClick: () => void;
  };
  extraFilters?: React.ReactNode;
}

export const Filters = <TData,>({
  table,
  translation,
  searchLabel,
  cta,
  extraFilters,
}: ITableFilters<TData>) => {
  return (
    <div className="flex md:items-center items-start justify-between pb-4 pt-6 gap-2 md:flex-row flex-wrap">
      {cta && (
        <Button onClick={cta.onClick} aria-label={`Add ${cta.label}`}>
          {cta.label}
        </Button>
      )}

      <div className="flex items-center gap-3 flex-1 min-w-0 flex-wrap">
        {extraFilters}
        <Input
          placeholder={translation('filterPlaceholder')}
          value={
            (table.getColumn(searchLabel)?.getFilterValue() as string) ?? ''
          }
          onChange={(event) =>
            table.getColumn(searchLabel)?.setFilterValue(event.target.value)
          }
          className="w-full lg:w-60"
        />
      </div>
    </div>
  );
};
